/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4879b989ad22a89959d8d90baaf573fbbd58d1e4";
